module.exports = __webpack_public_path__ + "static/customer-shopping-9aeebd2349343502f2fb547e20f06682.jpg";